import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface FrontendPageContentProps {
    children: ReactNode;
    className?: string;
}

export function FrontendPageContent({
    children,
    className,
}: FrontendPageContentProps) {
    return <div className={cn(className)}>{children}</div>;
}
